import { ProductSlim } from "../../contracts/Product";
import { DataMapper } from "..";

export default (data: any[]): (ProductSlim & { paginationToken: string })[] => {
  const mapper = DataMapper();
  return (
    data.map((node: any) => {
      if (node.node) {
        node = node.node;
      }
      const defaultVariant = node.defaultVariant ?? node.matchingVariant;

      return {
        id: node.id,
        name: node.name,
        hasMultipleVariants: node?.variants?.length > 1,
        path: node.path,
        brand: node.brand?.content?.text,
        variant: mapper.API.Object.APIProductVariantToProductVariant({
          ...defaultVariant,
          priceVariants: defaultVariant?.priceVariants
            ? Object.keys(defaultVariant.priceVariants).map((key) => ({
                identifier: key,
                ...defaultVariant.priceVariants[key],
              }))
            : [],
        }),
        sku: node.sku,
        topics:
          node.topics?.map((topic: any) => {
            return {
              name: topic.name,
              path: topic.path,
            };
          }) ?? [],
        paginationToken: node.paginationToken,
      };
    }) || []
  );
};
